// Base URL for the API
export const devUrl = "https://dev-api.equityedge.co.uk"; //dev server
export const liveUrl = "https://api.equityedge.co.uk"; //prod server
export const uatUrl = "https://backend-uat.equityedge.co.uk"; //uat server

export const baseUrl = (() => {
  const {hostname} = window.location;

  if (hostname === "localhost" || hostname === "192.168.0.106") {
    return uatUrl;
  } else if (hostname === "dev-user.equityedge.co.uk") {
    return devUrl;
  } else if (hostname === "user-uat.equityedge.co.uk") {
    return uatUrl;
  } else if (hostname === "app.equityedge.io") {
    return liveUrl;
  }
  return liveUrl;
})();

export {loadUser, signupRequest} from "./auth";
export {initiatePayment, applyCoupon, getPaymentStatus} from "./payment";
export {createSupportCases, getSupportTableDetails} from "./support";
export {updateUserDetailsRequest, getUserDetails, addUserAddress, getUserAddress, UpdateUserAddress} from "./user";
export {
  getFundingEvaluationPlansRequest,
  getPaymentHistoryRequest,
  getCompetitionListRequest,
  getUserAccountListRequest,
  getAccountMetricsRequest,
  getBalanceChartRequest,
  getTraderJournalRequest,
  createJournalTraderRequest,
  updateJournalTraderRequest,
  deleteJournalTraderRequest,
} from "./account";
